import { Badge } from "@devhop/ui";
import type { EmploymentStatus } from "@/modules/hr/employee-profile/domain/types";
import { daysUntil } from "@/modules/hr/employee-profile/domain/utils";

const STATUS_CONFIG: Record<
  EmploymentStatus,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline" }
> = {
  active: { label: "ຍັງເຮັດວຽກ", variant: "default" },
  probation: { label: "ທົດລອງງານ", variant: "secondary" },
  probation_failed: { label: "ບໍ່ຜ່ານທົດລອງ", variant: "destructive" },
  resigned: { label: "ລາອອກ", variant: "outline" },
  terminated: { label: "ຖືກເລີກຈ້າງ", variant: "destructive" },
};

type Props = {
  status: EmploymentStatus;
  probationEndDate?: string | null;
};

export function EmployeeStatusBadge({ status, probationEndDate }: Props) {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.active;

  // highlight ทดลองงานที่ใกล้ครบ (≤ 30 วัน)
  const isProbationWarning =
    status === "probation" &&
    probationEndDate != null &&
    daysUntil(probationEndDate) <= 30 &&
    daysUntil(probationEndDate) >= 0;

  return (
    <Badge
      variant={isProbationWarning ? "destructive" : cfg.variant}
      className="whitespace-nowrap"
    >
      {isProbationWarning ? `⚠ ${cfg.label}` : cfg.label}
    </Badge>
  );
}
